import { Injectable, signal } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface ConfirmOptions {
  message: string;
  title?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
}

interface PendingConfirm extends ConfirmOptions {
  resolve: (ok: boolean) => void;
}

@Injectable({ providedIn: 'root' })
export class ConfirmService {
  readonly pending = signal<PendingConfirm | null>(null);

  ask(opts: ConfirmOptions): Observable<boolean> {
    const subject = new Subject<boolean>();
    this.pending.set({
      ...opts,
      resolve: (ok) => {
        subject.next(ok);
        subject.complete();
        this.pending.set(null);
      },
    });
    return subject.asObservable();
  }

  resolve(ok: boolean) {
    this.pending()?.resolve(ok);
  }
}
